var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M.001 0H25v25.001H.001V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF641F",
    fillRule: "evenodd",
    d: "M25.01 12.111l-9.899 9.9-2.121-2.121 6.89-6.891H.001V10h19.378L12.99 3.611l2.121-2.122 9.899 9.9-.361.361.361.361z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrowIcon);
export default __webpack_public_path__ + "static/media/orange-arrow-icon.6243bae4e84411b8b0498504fb1c45a7.svg";
export { ForwardRef as ReactComponent };